import React from 'react';
import { Crown, Lock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const LimitReachedModal = ({ isOpen, onClose, type = 'recipe' }) => {
  const navigate = useNavigate();

  const content = {
    recipe: {
      title: 'Limite de Receitas Atingido',
      description: 'Você atingiu o limite de 5 receitas por mês do plano gratuito.',
      benefits: [
        '♾️ Receitas ilimitadas',
        '🤖 IA ilimitada',
        '👨‍👩‍👧 Famílias ilimitadas',
        '📅 Planejador semanal completo'
      ]
    },
    ai: {
      title: 'Limite de IA Atingido',
      description: 'Você atingiu o limite de 3 gerações de IA por semana do plano gratuito.',
      benefits: [
        '🤖 Gerações de IA ilimitadas',
        '♾️ Receitas ilimitadas',
        '🎤 Assistente de voz completo',
        '📊 Análises nutricionais detalhadas'
      ]
    }
  };

  const { title, description, benefits } = content[type] || content.recipe;

  const handleUpgrade = () => {
    onClose();
    navigate('/subscription');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl">
            <Lock className="w-6 h-6 text-orange-600" />
            {title}
          </DialogTitle>
          <DialogDescription className="text-base pt-2">
            {description}
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4">
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-200 rounded-lg p-4 mb-4">
            <div className="flex items-center gap-2 mb-3">
              <Crown className="w-5 h-5 text-orange-600" />
              <h3 className="font-semibold text-orange-900">Benefícios Premium:</h3>
            </div>
            <ul className="space-y-2">
              {benefits.map((benefit, index) => (
                <li key={index} className="text-sm text-gray-700 flex items-start">
                  <span className="mr-2">✓</span>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="text-center">
            <p className="text-2xl font-bold text-orange-600 mb-1">R$ 4,99/mês</p>
          </div>
        </div>
        
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto">
            Voltar
          </Button>
          <Button 
            onClick={handleUpgrade}
            className="w-full sm:w-auto bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-700 hover:to-amber-700 text-white"
          >
            <Crown className="w-4 h-4 mr-2" />
            Assinar Premium
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LimitReachedModal;
